import {
  IDiscountLineItem,
  ReferralTypes,
} from '@user/store/discountCode/typings'

export function useLineItemsReferralTypeLists(lineItems: IDiscountLineItem[]) {
  const existingCustomerList = lineItems.filter(
    (x) => x.referralType === ReferralTypes.Existing,
  )
  const newCustomerList = lineItems.filter(
    (x) => x.referralType === ReferralTypes.New,
  )
  return [existingCustomerList, newCustomerList]
}
